import { all, takeLatest, take, fork, call, select } from 'redux-saga/effects'
import * as R from 'domain/manager/recruiters'
import * as InviteRecruiter from 'domain/manager/anotherManagersRecruiter'
import { matchRoutes } from 'domain/router'

export function* profilePage() {
  yield all([
    fork(getProfile),
    fork(otherRecruiter),
    fork(preloadListsForRecruiter),
    fork(makeExternalRecruiter),
    fork(makeInternalRecruiter)
  ])
}

function* preloadListsForRecruiter() {
  const route = yield select(matchRoutes)
  if (route && route.params) {
    yield all([
      call(R.ensureGetRecruiterCandidates, {
        payload: { id: route.params.id },
        type: R.recruiterProfileCandidates.type
      }),
      call(R.ensureGetRecruiterJobs, {
        payload: { id: route.params.id },
        type: R.recruiterProfileJobs.type
      }),
      call(R.ensureGetRecruiterSkills, {
        payload: { id: route.params.id },
        type: R.recruiterProfileSkills.type
      })
    ])
  }
  yield takeLatest(R.recruiterProfileCandidates.type, R.ensureGetRecruiterCandidates)
  yield takeLatest(R.recruiterProfileJobs.type, R.ensureGetRecruiterJobs)
}

function* getProfile() {
  yield call(R.ensureGetRecruiterProfile)
  yield takeLatest(R.recruiterProfile.type, R.ensureGetRecruiterProfile)
  yield take(R.recruiterProfile.success)
}

function* otherRecruiter() {
  yield all([
    fork(inviteOtherRecruiter),
    fork(acceptOtherRecruiter),
    fork(closeOtherRecruiter),
    fork(declineOtherRecruiter)
  ])
}

function* inviteOtherRecruiter() {
  yield takeLatest(
    InviteRecruiter.inviteOtherRecruiter.type,
    InviteRecruiter.ensureInviteOtherRecruiter
  )
  yield take(InviteRecruiter.inviteOtherRecruiter.success)
}

function* acceptOtherRecruiter() {
  yield takeLatest(
    InviteRecruiter.acceptOtherRecruiter.type,
    InviteRecruiter.ensureAcceptOtherRecruiter
  )
  yield take(InviteRecruiter.acceptOtherRecruiter.success)
  yield call(R.ensureGetRecruiterProfile, { payload: true })
}

function* declineOtherRecruiter() {
  yield takeLatest(
    InviteRecruiter.declineOtherRecruiter.type,
    InviteRecruiter.ensureDeclineOtherRecruiter
  )
  yield take(InviteRecruiter.declineOtherRecruiter.success)
  yield call(R.ensureGetRecruiterProfile, { payload: true })
}

function* closeOtherRecruiter() {
  yield takeLatest(
    InviteRecruiter.closeOtherRecruiter.type,
    InviteRecruiter.ensureCloseOtherRecruiter
  )
  yield take(InviteRecruiter.closeOtherRecruiter.success)
  yield call(R.ensureGetRecruiterProfile, { payload: true })
}

function* makeExternalRecruiter() {
  yield takeLatest(R.makeRecruiterExternal.TRIGGER, R.ensureMakeRecruiterExternal)
}

function* makeInternalRecruiter() {
  yield takeLatest(R.makeRecruiterInternal.TRIGGER, R.ensureMakeRecruiterInternal)
}
